import gql from 'graphql-tag';

// A deep link to the preview doesn't load the policy store. Fetch only the fields needed for
// vehicle and driver labels. VIN and driver id are required: policyDetailsFromSegments dedupes
// merged cars by VIN and drivers by id, so without them every item after the first is dropped.
export const GET_CD_VEHICLE_LABELS = gql`
  query CdVehicleLabels($policyId: ID!, $accountId: ID!, $previewId: ID!) {
    before: getPolicy(id: $policyId, accountId: $accountId) {
      ...CdVehicleLabelPolicy
    }
    after: getPolicyPreview(policyId: $policyId, previewId: $previewId) {
      policy {
        ...CdVehicleLabelPolicy
      }
    }
  }
  fragment CdVehicleLabelPolicy on Policy {
    segments {
      segmentId
      clarionDoorId
      cars {
        VIN
        year
        symbolMake
        symbolModel
        make
        model
      }
      drivers {
        id
        firstName
        lastName
      }
    }
  }
`;
